import React, { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap';
import axios from 'axios'
import {baseUrl} from '../../../config/baseUrl'
import Spinner from '../../common/Spinner';
import { helpers, goBackButton } from '../../../helpers';

const FailurePage = ({ encryptData, failedMessage, message, cancelUrl, base64Data, dataDecode, showCashPaymentBtn, cashPaymentUrl }) => {
  const [loading, setLoading] = useState(false)
  const [loadingCashPayment, setLoadingCashPayment] = useState(false)
  const [show, setShow] = useState(true);
  const [providerUrl, setBaseUrl] = useState("");
  const [providerName, setProviderName] = useState("");
  const [orderInfo, setOrderInfo] = useState('');
  const backUrl = dataDecode.cvv_exists ? dataDecode.back_url : `/${providerName}?data=${encryptData}&response=${base64Data}&via=1`;

  const cancelPayment = async (data) => {
    try {
      const url = `${providerUrl}/sale/cancel`

      const response = await axios.post(url, {data,error_message: message})
      const {cancel_url} = response.data.data
      window.location.replace(cancel_url)
    } catch (error) {
      console.log('Error happened here:', error);
      window.location.replace(dataDecode?.cancel_url);
    }
  }
  const checkPaymentStatus = async (data) => {
    try {
      setShow(true);
      const url = `${baseUrl.earth}/decrypt`;
      //using decrypt endpoint to check the payment status
      const response = await axios.post(url, { data,error_message: failedMessage })
      setOrderInfo(response);
      setShow(false);
      //if getting response do nothing
    } catch (error) {
      console.log('Error:', error?.message);
      let message, redirect_url;
      if (error.response?.data) {
        message = error.response.data.error?.message;
        redirect_url = error.response.data.error?.redirect_url;
      } else {
        message = error.message;
      }
      setOrderInfo(error.response);
      //if payment done will be getting status code of 500 -> redirect to success page
      if (message === 'Payment already done' && error.response.status === 500) {
        setTimeout(() => { window.location.replace(redirect_url); }, 2000)
      }
      setShow(false);
    }
  }
  const handleCancelEvent = () => {
    setLoading(true)
    if (providerName === 'earth' & message) {
      // only cancel the payment if the payment is done through CS or CS not Gpay or Apay
      cancelPayment(encryptData);
    } else {
      window.location.replace(dataDecode?.cancel_url);
    }
  }
  const handleCashPayment =  () => {
    setLoadingCashPayment(true);
    window.location.replace(cashPaymentUrl)
  }
  useEffect(() => {
    var { url, name } = helpers.GetProviderConfig(dataDecode?.provider);
    setBaseUrl(url);
    setProviderName(name);
    
    checkPaymentStatus(encryptData);
  }, [])

  return show ? <Spinner message='Processing, please wait...' /> : (
    <div className='container col d-flex justify-content-center mt-4'>
    <div className='col-sm-6 col-md-6 col-lg-5 col-xl-4'>
      { !showCashPaymentBtn && <div className="btn btn-light back-btn-container" onClick={() => goBackButton(backUrl)}>« Back</div> }
      <div className='col-md-12 card'>
      <br></br>
      <b>{failedMessage}</b> 
      {failedMessage?.includes("The card used has expired.") ? (
              <p className="lead mt-5">
               The card used has expired. Please try again with valid 
               card details.
              </p>
            ) : (
              <p className='lead mt-5'>Your payment for order #{dataDecode?.order_id || orderInfo?.data?.data?.order_id || orderInfo?.data?.error?.order_id} was not completed.  
              If an amount was debited, it will be refunded to your card within 3 to 5 working days.</p>
            )}

          <p className='lead' style={{ color:'grey', fontSize: 12}}>{message}</p>
          {!dataDecode.cvv_exists&&<Button
            className=' btn-block'
            variant='success'
            href={`/${providerName}?data=${encryptData}&response=${base64Data}&via=1`}
            data-loading-text='Processing, please wait...'
          >
            Try Again
          </Button>}

          <Button
            className=' btn-block  mb-5'
            variant='info'
            disabled={loading}
            data-loading-text='Processing, please wait...'
            onClick={handleCancelEvent}
          >
            {!loading ? (
              'Cancel'
            ) : (
              <>
                <div
                  className='spinner-border spinner-border-sm'
                  role='status'
                ></div>
                Please Wait...
              </>
            )}
          </Button>
          { showCashPaymentBtn && <Button
              className=' btn-block'
              variant='primary'
              disabled={loading}
              data-loading-text='Processing, please wait...'
              onClick={handleCashPayment}
          >
            {!loadingCashPayment ? (
                'Pay Cash'
            ) : (
                <>
                  <div
                      className='spinner-border spinner-border-sm'
                  > </div>
                  Please Wait...
                </>
            )}
          </Button>}
        </div>
      </div>
    </div>
  )
}

export default FailurePage
